import { FilterItem } from 'models';
import { IDeviceCount } from 'pages/ManageDevicesPage/types';

export const useManageDevicesFilter = (devicesCount?: IDeviceCount, locale?: any, isEnabledTachyon?: boolean) => {
  const manageDevicesFilter: FilterItem[] = [
    {
      label: locale?.performance || 'Performance',
      keyName: 'performance',
      childs: [
        {
          id: 'No Data',
          label: locale?.performanceStatus?.noData || 'No data',
          value: 'No data',
          count: devicesCount?.mcpCategoryCounts?.noData || 0,
        },
        {
          id: 'Poor',
          label: locale?.performanceStatus?.poor || 'Poor',
          value: 'Poor',
          count: devicesCount?.mcpCategoryCounts?.poor || 0,
        },
        {
          id: 'Need Attention',
          label: locale?.performanceStatus?.needAttention || 'Need Attention',
          value: 'Need Attention',
          count: devicesCount?.mcpCategoryCounts?.needAttention || 0,
        },
        {
          id: 'Sufficient',
          label: locale?.performanceStatus?.sufficient || 'Sufficient',
          value: 'Sufficient',
          count: devicesCount?.mcpCategoryCounts?.sufficient || 0,
        },
        {
          id: 'Very Good',
          label: locale?.performanceStatus?.veryGood || 'Very Good',
          value: 'Very Good',
          count: devicesCount?.mcpCategoryCounts?.veryGood || 0,
        },
      ],
    },
    {
      label: locale?.status,
      keyName: 'status',
      childs: [
        {
          id: 'In Use',
          label: locale?.inUse|| 'In Use',
          value: 'In Use',
          count: devicesCount?.statusCount?.inUseCount || 0,
        },
        {
          id: 'Ready for Refresh',
          label: locale?.readyForRefresh || 'Ready for Refresh',
          value: 'Ready for Refresh',
          count: devicesCount?.statusCount?.readyForRefreshCount || 0,
        },
        {
          id: 'Others',
          label: locale?.others || 'Others',
          value: 'Others',
          count: devicesCount?.statusCount?.others || 0,
        },
      ],
    },
  ];

  if(!isEnabledTachyon) manageDevicesFilter.shift();

  return { manageDevicesFilter };
};
